const backendHost = process.env.REACT_APP_BACKEND_HOST || 'http://localhost:4000';

/** Same-session fetch: the API httpOnly cookie is sent; JS never reads a JWT. */
export function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  headers.delete('authorization');
  headers.delete('Authorization');
  return fetch(`${backendHost}${path}`, { ...init, credentials: 'include', headers });
}

export function apiUrl(path: string): string {
  return `${backendHost}${path}`;
}
